import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchCampaignRequirement as fetchCampaignRequirementAPI } from "services/api/campaign";
import { ERROR } from "types";
import { CampaignRequirementResponse } from "types/campaign/requirement";
import { getErrorMessage } from "utils/helpers";
import { handleInfluencerLocationData } from "./utils";

export const fetchCampaignRequirement = createAsyncThunk<CampaignRequirementResponse, string, { rejectValue: string }>(
    'campaign/requirement/fetch',
    async (campaignId, { rejectWithValue }) => {
        try {
            const requirements = await fetchCampaignRequirementAPI(campaignId);
            return handleInfluencerLocationData(requirements);
        } catch (error) {
            return rejectWithValue(getErrorMessage(error, ERROR.NOT_FOUND));
        }
    }
);
